import axios from '../../../core/services/axios';

/* eslint-disable import/prefer-default-export */

export const fetchInitiatives = (params) => axios.get('/api/initiatives', {
  params,
});
